module.exports = __webpack_public_path__ + "img/fr_Ecran 6.3a1b228e.jpg";